// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"4f827549","701":"5ab6dabe"}[chunkId] + ".chunk.js";
};